import Vue from "vue";
import AppConfig from "@AssemblyInstructions/Scripts/Config/AppConfig";
import { router } from "@AssemblyInstructions/Scripts/Config/RouteConfig";
import { store } from "@AssemblyInstructions/Scripts/Config/StoreConfig";
import Axios from "axios";
import StyleHelper from "@Scripts/Infrastructure/StyleHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["AssemblyInstructions", "CookieToast"]
        });

        this.initRequestVerificationToken();

        AppConfig.AddComponents();
        AppConfig.AddDirectives();

        StyleHelper.resetCssAnimations();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() { }
        });

        (<any>window).App.instances.vm = vm;

        this.setAnalytics();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static setAnalytics() {
        let assemblyInstructions = document.querySelectorAll(".ga-event[data-gacategory=\"assembly-instructions\"]");
        for (const item of assemblyInstructions) {
            if (item) {
                item.addEventListener("click", function (event) {
                    GTagHelper.sendCustomEvent("click", {assembly_instructions: "original"});
                }, false);
            }
        }
    }
}